module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-mv-img-963bc05870c035307510eafc8f742b5a.png";